import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useApi } from '../../hooks/useApi';
import { AREA_TEXTS, METHOD_TEXTS } from '../../consts';
import Util from '../../util';
import Spinner from '../../components/Spinner';

type ApiConvDonee = {
  donee_id: number;
  donee_no: number;
  name: string;
}

const New = () => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const [ doneeId, setDoneeId ] = useState<number>();
  const [ donatedAt, setDonatedAt ] = useState<Date>(today);
  const [ area, setArea ] = useState<string>();
  const [ method, setMethod ] = useState<string>();

  const [ convDonees, setConvDonees ] = useState<ApiConvDonee[]>();
  const { get, post, loading } = useApi();

  const navigate = useNavigate();

  useEffect(() => {
    get({
      endpoint: `/api/v1/convs/index_for_records`,
      onSuccess: (res) => {
        setConvDonees(res.data);
      },
      onError: (err) => {
        console.error("Error fetching conv donees:", err);
      },
    });
  }, [ get ])

  const doneeOptions = convDonees?.map(cd => {
    return (
      <option key={ cd.donee_id } value={ cd.donee_id }>
        { cd.name } (No. { cd.donee_no })
      </option>
    )
  })

  const areaOptions = Object.keys(AREA_TEXTS).map(a => {
    return (
      <option key={ a } value={ a }>{ AREA_TEXTS[a] }</option>
    )
  })

  const methodOptions = Object.keys(METHOD_TEXTS).map(m => {
    return (
      <option key={ m } value={ m }>{ METHOD_TEXTS[m] }</option>
    )
  })

  const handleSubmit = () => {
    if (!doneeId || !donatedAt || !area || !method) {
      toast.error("全ての項目を入力してください。");
      return
    }

    post({
      endpoint: `/api/v1/donor_records`,
      body: {
        donee_id: doneeId,
        donated_at: Util.toDateStr(donatedAt),
        area: area,
        meth: method
      },
      onSuccess: (res) => {
        toast.success("提供実績を登録しました。承認されると提供回数に反映されます。");
        navigate('/mypage/records')
      },
      onError: (err) => {
        toast.error("登録に失敗しました。時間をおいて再度お試しください。");
      },
    });
  }

  return (
    <section className="donor_offerregister">
      { loading && <Spinner overlay={ true } /> }
      <h2 className="main_title"><span>提供実績の新規登録</span></h2>
      <div className="form">
        <dl className="graf_list">
          <dt>提供した人</dt>
          <dd>
            <div className="select select01">
              <select
                value={ doneeId }
                onChange={ e => setDoneeId(Number(e.target.value)) }
              >
                <option value="">選択してください</option>
                { doneeOptions }
              </select>
            </div>
          </dd>
          <dt>提供した日</dt>
          <dd>
            <input
              type="date"
              // value={ donatedAt?.toISOString().slice(0, 10) }
              value={ Util.toDateStr(donatedAt) }
              onChange={ e => setDonatedAt(new Date(e.target.value)) }
            />
          </dd>
          <dt>エリア</dt>
          <dd>
            <div className="select select01">
              <select
                value={ area }
                onChange={ e => setArea(e.target.value) }
              >
                <option value="">選択してください</option>
                { areaOptions }
              </select>
            </div>
          </dd>
          <dt>提供方法</dt>
          <dd>
            <div className="select select01">
              <select
                value={ method }
                onChange={ e => setMethod(e.target.value) }
              >
                <option value="">選択してください</option>
                { methodOptions }
              </select>
            </div>
          </dd>
        </dl>
        <p>※提供を受けた人はメッセージ履歴のある方からのみ選択可能です。<br/>※公開されるのは実績回数の合計値のみです。<br/>※提供を受けた人の名前などが公開されることはありません。</p>
        <input type="submit" value="登録する" className="w_bluebtn" onClick={ handleSubmit } />
      </div>
    </section>
  );
}

export default New;
